import { put, takeEvery, select } from 'redux-saga/effects'
import { push } from 'connected-react-router'

import { showSuccess } from 'store/entities/toastr/utils'
import { tryDifferentActivity, setFalsePendingStatus } from 'store/entities/differentActivities/actions'
import { activityActions } from 'store/entities/identity/actions'
import { isResponseFailed } from 'helpers/responseHelpers'
import { getActivityUserActivityId } from 'store/entities/activity/selectors'

export default function* handleChangeActivityRequest() {
  yield takeEvery(tryDifferentActivity.success, changeActivityHandler)
}

export function* changeActivityHandler({ meta }) {
  const userActivityId = yield select(getActivityUserActivityId)
  const activityId = meta.activityId
  const res = yield activityActions.commit.call({ activityId, userActivityId })
  if (!isResponseFailed(res)) {
    yield put(push(`/dashboard`))
    yield put(setFalsePendingStatus())
    yield showSuccess({ content: `You successfully changed your today's activity` })
  }
}
